import utf8 from 'utf8';
import {decode as atob, encode as btoa} from 'base-64';

import * as ht from './_ht';

export const cvtUi8ToB64 = (pa_val: ht.ls) => { // uint8Array to base64
  return btoa(String.fromCharCode(...(new Uint8Array(pa_val))));
};

export const cvtB64ToUi8 = (pa_val: ht.s) => { // base64 to uint8Array
  return atob(pa_val).split('').map( _c => _c.charCodeAt(0) );
};

export const cvtSrgToB64 = (pa_val: ht.s) => { // string to base64
  return btoa(utf8.encode(pa_val));
};

export const cvtB64ToSrg = (pa_val: ht.s) => { // base64 to string
  return utf8.decode(atob(pa_val));
};
